module.exports = __webpack_public_path__ + "media/images/pic/teachers/animation-image-7ea956c938956431b620865d2705a05c.jpg";